import {useMutation, UseMutationResult, useQueryClient} from "@tanstack/react-query";
import {IDocPayment} from "../../../../../../../utils/interfaces/my_documents/doc_payment/IDocPayment";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiUpdateDocPayment = (): UseMutationResult<IDocPayment, CustomAxiosError, {
    id: number;
    data: any
}, unknown> => {
    const queryClient = useQueryClient();
    const {selectedCompany} = useAuth()

    const {put} = useApiCalls()


    async function doUpdate(company_token: string | undefined,
                            pk: number | undefined,
                            data: any): Promise<IDocPayment> {
        try {
            const response = await put(`/api/company/${company_token}/my_documents/doc_payment/${pk}/`, data);
            return response.data as IDocPayment;
        } catch (error) {
            throw error;
        }
    }

    return useMutation<IDocPayment, CustomAxiosError, {
        id: number;
        data: any
    }, unknown>({
        mutationFn: async ({id, data}) => {
            return await doUpdate(selectedCompany?.company_token, id, data);
        },
        onSuccess: async (data) => {
            await queryClient.invalidateQueries({queryKey: ['useApiGetDocPayment', data.id]});
            await queryClient.invalidateQueries({queryKey: ["useApiGetDocPayments", data.doc?.id]});
            await queryClient.invalidateQueries({queryKey: ['useApiGetRicevuteBancarie']});
        },
    });
};


export default useApiUpdateDocPayment;